<div class="h-1 border-b border-gray-200" *ngIf="!showSelectedItems">
    <mat-progress-bar *ngIf="!loaded" mode="indeterminate"></mat-progress-bar>
</div>
<div class="flex items-center py-4 pl-2 border-b" *ngIf="showSelectedItems">
    <button class="mr-1" mat-icon-button (click)="hideSelectedItemsPanel()">
        <em class="ti ti-arrow-narrow-left icon-size-7 text-gray-500"></em>
    </button>
    <div class="ml-1 flex items-center">
        <span class="text-lg">{{'dataPicker.invoice.selected_invoice' | translate}}</span>
        <badge class="ml-2" [options]="getBadgeOptions()">
        </badge>
    </div>
</div>
<ul role="list" class="divide-y divide-gray-200 overflow-y-auto zuper-scrollbar data-picker-list-content-height"
    *ngIf="invoices.length">
    <li class="invoice-data-picker-list-ele" *ngFor="let invoice of invoices">
        <div class="hover:bg-gray-50 group relative flex items-center py-3 px-5"
            [ngClass]="{'cursor-pointer': selectOption === 'readOnly'}"
            (click)="selectOption === 'readOnly' ? viewInvoiceDetails($event, invoice.invoice_uid) : null">
            <a class="-m-1 block flex-1 p-1">
                <div class="relative flex min-w-0 flex-1 items-center">
                    <mat-checkbox (change)="selectInvoice($event, invoice)" [checked]="isSelectedInvoice(invoice)"
                        *ngIf="selectOption === 'multiSelect'" color="primary" disableRipple="true">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="invoicesContent"></ng-container>
                        </div>
                    </mat-checkbox>
                    <mat-radio-button (change)="selectInvoice($event, invoice)" [checked]="isSelectedInvoice(invoice)"
                        *ngIf="selectOption === 'select'" color="primary" disableRipple="true">
                        <div class="ml-4 truncate">
                            <ng-container *ngTemplateOutlet="invoicesContent"></ng-container>
                        </div>
                    </mat-radio-button>
                    <ng-container *ngIf="selectOption === 'readOnly'">
                        <div class="truncate w-full">
                            <ng-container *ngTemplateOutlet="invoicesContent"></ng-container>
                        </div>
                    </ng-container>
                    <ng-template #invoicesContent>
                        <div class="flex items-center justify-between">
                            <div>
                                <div class="flex flex-row space-x-2">
                                    <p class="truncate text-lg font-medium text-gray-900 cursor-pointer">
                                        {{invoice?.prefix ?? ''}}{{invoice?.invoice_no ?? ''}}
                                    </p>
                                </div>
                                <div class="flex flex-row space-x-2 mt-1" *ngIf="utilityService.hasPermission('product.show_selling_price') && !utilityService.isEmptyOrUndefined(invoice?.total)">
                                    <p class="truncate text-base text-gray-500">
                                        {{currency + ' ' + (invoice?.total | number:digitsInfo)}}
                                    </p>
                                </div>
                            </div>
                            <div class="ml-auto mr-4">
                                <badge *ngIf="invoice?.invoice_status"
                                    [options]="getStatusBadgeOptions(invoice?.invoice_status)"></badge>
                            </div>
                        </div>
                    </ng-template>
                    <button mat-icon-button class="cursor-pointer ml-auto"
                        matTooltip="{{ updateArrowTooltipText(invoice.invoice_uid) | translate }}"
                        matTooltipPosition="above" *ngIf="!showSpinLoading(invoice.invoice_uid)"
                        [ngClass]="rotateArrowIcon(invoice.invoice_uid)"
                        (click)="viewInvoiceDetails($event, invoice.invoice_uid)">
                        <mat-icon role="img" class="mat-icon notranslate mat-icon-no-color" aria-hidden="true"
                            data-mat-icon-type="svg" data-mat-icon-name="x" data-mat-icon-namespace="heroicons_outline">
                            <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-chevron-down"
                                width="24" height="24" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor"
                                fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none">
                                </path>
                                <polyline points="6 9 12 15 18 9"></polyline>
                            </svg>
                        </mat-icon>
                    </button>
                    <div class="ml-auto py-2.5 h-10" *ngIf="showSpinLoading(invoice.invoice_uid)">
                        <mat-spinner class="ml-auto data-picker-spinner md:mr-3" [diameter]="18" style="width: 18px;height: 18px">
                        </mat-spinner>
                    </div>
                </div>
            </a>
        </div>
        <div class="p-4 bg-gray-100"
                *ngIf="('invoice_details_' + invoice.invoice_uid === invoiceEleId) && invoiceDetails && !isSpinLoading">
                <div class="bg-card rounded relative">
                    <a target="_blank" class="hidden" #viewFullDetails
                        href="{{viewInvoiceFullDetails(invoice.invoice_uid)}}"></a>
                    <span class="cursor-pointer absolute right-0 pt-1 pr-1 z-50" (click)="viewFullDetails.click($event)"
                        matTooltip="{{'text.view_details.new_tab' | translate}}" matTooltipPosition="left">
                        <button mat-icon-button>
                            <mat-icon class="text-xl">open_in_new</mat-icon>
                        </button>
                    </span>
                    <div class="text-base">
                        <div class="px-2 truncate grid grid-cols-2">
                            <div *ngIf="invoiceDetails.customer?.customer_first_name"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'customer' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="invoiceDetails.customer?.is_deleted === true || !utilityService.hasModuleAccess('CUSTOMER')">
                                    {{invoiceDetails.customer.customer_first_name}}
                                    {{invoiceDetails.customer.customer_last_name ?? ''}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('CUSTOMER', invoiceDetails.customer.customer_uid)"
                                        *ngIf="!invoiceDetails.customer?.is_deleted && utilityService.hasModuleAccess('CUSTOMER')">
                                        {{invoiceDetails.customer.customer_first_name}}
                                        {{invoiceDetails.customer.customer_last_name ?? ''}}</a>
                                </p>
                            </div>
                            <div *ngIf="invoiceDetails.organization"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'text.organization_name' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="invoiceDetails.organization?.is_deleted === true || !utilityService.hasModuleAccess('ORGANIZATION')">
                                    {{invoiceDetails.organization?.organization_name}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('ORGANIZATION', invoiceDetails.organization.organization_uid)"
                                        *ngIf="!invoiceDetails.organization?.is_deleted && utilityService.hasModuleAccess('ORGANIZATION')">
                                        {{invoiceDetails.organization?.organization_name}}</a>
                                </p>
                            </div>
                            <div *ngIf="invoiceDetails.estimate"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'text.quote_no' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="invoiceDetails.estimate?.is_deleted === true || !utilityService.hasModuleAccess('ESTIMATES')">
                                    {{invoiceDetails.estimate?.estimate_no}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('ESTIMATES', invoiceDetails.estimate.estimate_uid)"
                                        *ngIf="!invoiceDetails.estimate?.is_deleted && utilityService.hasModuleAccess('ESTIMATES')">
                                        {{invoiceDetails.estimate?.estimate_no}}</a>
                                </p>
                            </div>
                            <div *ngIf="invoiceDetails.job"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'job' | translate}}</p>
                                <p class="mt-1 text-gray-900"
                                    *ngIf="invoiceDetails.job?.is_deleted === true || !utilityService.hasModuleAccess('JOB')">
                                    {{invoiceDetails?.job.prefix ?? ''}}{{invoiceDetails?.job.work_order_number ?? ''}} -
                                    {{invoiceDetails?.job.job_title}}</p>
                                <p class="mt-1">
                                    <a class="text-gray-900 hover:underline hover:text-primary cursor-pointer" target="_blank"
                                        [routerLink]="utilityService.getLink('JOB', invoiceDetails.job.job_uid)"
                                        *ngIf="!invoiceDetails.job?.is_deleted && utilityService.hasModuleAccess('JOB')">
                                        {{invoiceDetails?.job.prefix ?? ''}}{{invoiceDetails?.job.work_order_number ?? ''}} -
                                        {{invoiceDetails?.job.job_title}}</a>
                                </p>
                            </div>
                            <div *ngIf="invoiceDetails.invoice_date"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'text.invoice_date' | translate}}</p>
                                <p class="mt-1 text-gray-900">
                                    {{invoiceDetails.invoice_date | dateformat}}</p>
                            </div>
                            <div *ngIf="invoiceDetails.due_date"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'due.date.text' | translate}}</p>
                                <p class="mt-1 text-gray-900">
                                    {{invoiceDetails.due_date | dateformat}}</p>
                            </div>
                            <div *ngIf="invoiceDetails.created_at"
                                class="min-w-0 space-y-1 z-20 items-center py-2 md:px-2 cursor-pointer quote-details-fields dark:bg-hover">
                                <p class="font-medium leading-5 truncate text-gray-500">
                                    {{'created.at.text' | translate}}</p>
                                <p class="mt-1 text-gray-900">
                                    {{invoiceDetails.created_at | datetime}}</p>
                            </div>
                        </div>
                    </div>
                    <div class="px-2 py-2 border-t text-base"
                        *ngIf="invoiceDetails.customer_service_address && (invoiceDetails.customer_service_address.street || invoiceDetails.customer_service_address.state)">
                        <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                            {{'text.service_address' | translate}} </p>
                        <div class="px-3">
                            <p *ngIf="invoiceDetails.customer_service_address.first_name" class="text-base mb-2">
                                {{invoiceDetails.customer_service_address.first_name}}
                                {{invoiceDetails.customer_service_address.last_name}}</p>
                            <p *ngIf="invoiceDetails.customer_service_address.street" class="text-base mb-2">
                                {{invoiceDetails.customer_service_address.street}}</p>
                            <p *ngIf="invoiceDetails.customer_service_address.landmark" class="text-base mb-2">
                                {{invoiceDetails.customer_service_address.landmark}}</p>
                            <p *ngIf="invoiceDetails.customer_service_address.city" class="text-base mb-2">
                                {{invoiceDetails.customer_service_address.city}}</p>
                            <p *ngIf="invoiceDetails.customer_service_address.state" class="text-base mb-2">
                                {{invoiceDetails.customer_service_address.state}}
                                {{invoiceDetails.customer_service_address.zip_code ? '- ' +
                                invoiceDetails.customer_service_address.zip_code : '' }}</p>
                            <p *ngIf="invoiceDetails.customer_service_address.country" class="text-base">
                                {{invoiceDetails.customer_service_address.country}}</p>
                        </div>
                    </div>
                    <div class="px-2 py-2 border-t text-base"
                        *ngIf="invoiceDetails.customer_billing_address && (invoiceDetails.customer_billing_address.street || invoiceDetails.customer_billing_address.state)">
                        <p class="font-medium leading-5 truncate text-gray-500 mb-3 ml-3">
                            {{'billing.address.text' | translate}} </p>
                        <div class="px-3">
                            <p *ngIf="invoiceDetails.customer_billing_address.first_name" class="text-base mb-2">
                                {{invoiceDetails.customer_billing_address.first_name}}
                                {{invoiceDetails.customer_billing_address.last_name}}</p>
                            <p *ngIf="invoiceDetails.customer_billing_address.street" class="text-base mb-2">
                                {{invoiceDetails.customer_billing_address.street}}</p>
                            <p *ngIf="invoiceDetails.customer_billing_address.landmark" class="text-base mb-2">
                                {{invoiceDetails.customer_billing_address.landmark}}</p>
                            <p *ngIf="invoiceDetails.customer_billing_address.city" class="text-base mb-2">
                                {{invoiceDetails.customer_billing_address.city}}</p>
                            <p *ngIf="invoiceDetails.customer_billing_address.state" class="text-base mb-2">
                                {{invoiceDetails.customer_billing_address.state}}
                                {{invoiceDetails.customer_billing_address.zip_code ? '- ' +
                                invoiceDetails.customer_billing_address.zip_code : '' }}</p>
                            <p *ngIf="invoiceDetails.customer_billing_address.country" class="text-base">
                                {{invoiceDetails.customer_billing_address.country}}</p>
                        </div>
                    </div>
                </div>
            </div>
    </li>
</ul>
<div class="overflow-hidden data-picker-list-content-height flex flex-col items-center justify-center"
    *ngIf="!invoices.length && loaded && !showSelectedItems">
    <div class="flex flex-col items-center justify-center">
        <img class="w-40 m-auto" src="assets/images/svgs/no_contracts_or_quote_found.svg" alt="No Invoice Found">
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="onSearch">{{'dataPicker.invoice.not_found' | translate}}
            '{{searchKey}}'</h4>
        <h4 class="font-medium mt-4 text-secondary text-base" *ngIf="!onSearch">{{'dataPicker.invoice.placeholder' | translate}}
        </h4>
    </div>
</div>